import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1079680497/src/medh-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1079680497/src/medh-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1079680497/src/medh-web/src/assets/images/herobanner/herobanner__1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1079680497/src/medh-web/src/assets/images/herobanner/herobanner__2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1079680497/src/medh-web/src/assets/images/herobanner/herobanner__3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1079680497/src/medh-web/src/assets/images/herobanner/herobanner__5.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1079680497/src/medh-web/src/components/sections/error/Error1.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1079680497/src/medh-web/src/components/shared/wrappers/PageWrapper.tsx");
